import React from 'react';
import { Box, Typography, useTheme } from '@material-ui/core';
import TitleMLStyled from './TitleMLStyles';

export default ({ title, fontSize, p, subtitleTitle, isError }) => {
  const theme = useTheme();
  return (
    <TitleMLStyled theme={theme} fontSize={fontSize} p={p} isError={isError}>
      <Box display="flex" gap="0 16px" alignItems="flex-end">
        <Typography variant="body1" className="title-style">
          {title}
        </Typography>
        {subtitleTitle && (
          <Typography variant="body1" className="subtitle-title-style">
            {subtitleTitle}
          </Typography>
        )}
      </Box>
    </TitleMLStyled>
  );
};
